import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, LayoutGridIcon, ListIcon } from 'lucide-react';
export function PivotSelectionStep({
  initialData = [],
  onUpdate
}) {
  const [pivots, setPivots] = useState(initialData.length ? initialData : [{
    name: '',
    length: 400,
    area: 50,
    degrees: 360,
    tradername: 'Western',
    model: 'CP600',
    price: 65000
  }]);
  const [viewMode, setViewMode] = useState('list'); // "list" or "grid"
  const handleAddPivot = () => {
    const newPivot = {
      name: '',
      length: 400,
      area: 50,
      degrees: 360,
      tradername: 'Western',
      model: 'CP600',
      price: 60000
    };
    setPivots([...pivots, newPivot]);
    onUpdate([...pivots, newPivot]);
  };
  const handleRemovePivot = index => {
    const newPivots = pivots.filter((_, i) => i !== index);
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  const handlePivotChange = (index, field, value) => {
    const newPivots = [...pivots];
    newPivots[index] = {
      ...newPivots[index],
      [field]: value
    };
    // Auto calculate area based on length and degrees
    if (field === 'length' || field === 'degrees') {
      const lengthInMeters = parseFloat(newPivots[index].length);
      const degrees = parseFloat(newPivots[index].degrees);
      const areaHa = Math.round(Math.PI * Math.pow(lengthInMeters, 2) * (degrees / 360) / 10000);
      newPivots[index].area = areaHa;
    }
    // Auto adjust price based on model and length
    if (field === 'model' || field === 'length') {
      const basePrice = field === 'model' && value === '8120' ? 70000 : 60000;
      const lengthFactor = newPivots[index].length / 400; // Adjust price based on length
      newPivots[index].price = Math.round(basePrice * lengthFactor);
    }
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  return <div className="space-y-6" data-id="element-4296">
      <div className="flex justify-between items-center" data-id="element-4297">
        <div className="text-white text-xl font-medium" data-id="element-4298">
          Select Pivot Machines
        </div>
        <div className="flex bg-slate-800/50 rounded-lg p-1" data-id="element-4299">
          <button className={`p-2 rounded ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-4300">
            <ListIcon size={18} data-id="element-4301" />
          </button>
          <button className={`p-2 rounded ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-4302">
            <LayoutGridIcon size={18} data-id="element-4303" />
          </button>
        </div>
      </div>

      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4304">
        <div className="flex items-start" data-id="element-4305">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4306" />
          <div data-id="element-4307">
            <h3 className="text-white font-medium mb-1" data-id="element-4308">
              Pivot Selection Guide
            </h3>
            <p className="text-blue-200 text-sm" data-id="element-4309">
              Select the pivot machines you want to include in this quote. You
              can add multiple pivots with different specifications. The system
              will automatically calculate coverage area based on length and
              degrees.
            </p>
          </div>
        </div>
      </div>

      {viewMode === 'list' ?
    // List View
    <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4310">
          <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4311">
            <div className="col-span-2" data-id="element-4312">Pivot Name</div>
            <div className="col-span-1 text-center" data-id="element-4313">Length (m)</div>
            <div className="col-span-1 text-center" data-id="element-4314">Area (ha)</div>
            <div className="col-span-1 text-center" data-id="element-4315">Degrees</div>
            <div className="col-span-2" data-id="element-4316">Tradername</div>
            <div className="col-span-2" data-id="element-4317">Model</div>
            <div className="col-span-2 text-right pr-8" data-id="element-4318">Price</div>
            <div className="col-span-1" data-id="element-4319"></div>
          </div>
          <div className="p-2" data-id="element-4320">
            {pivots.map((pivot, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4321">
                <div className="col-span-2" data-id="element-4322">
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Pivot name" data-id="element-4323" />
                </div>
                <div className="col-span-1" data-id="element-4324">
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="100" max="1000" step="1" data-id="element-4325" />
                </div>
                <div className="col-span-1" data-id="element-4326">
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" readOnly data-id="element-4327" />
                </div>
                <div className="col-span-1" data-id="element-4328">
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" max="360" step="1" data-id="element-4329" />
                </div>
                <div className="col-span-2" data-id="element-4330">
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4331">
                    <option value="Western" data-id="element-4332">Western</option>
                    <option value="Pierce" data-id="element-4333">Pierce</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4334">
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4335">
                    <option value="CP600" data-id="element-4336">CP600</option>
                    <option value="8120" data-id="element-4337">8120</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4338">
                  <div className="relative" data-id="element-4339">
                    <span className="absolute left-3 top-2 text-gray-400" data-id="element-4340">
                      $
                    </span>
                    <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" min="0" step="100" data-id="element-4341" />
                  </div>
                </div>
                <div className="col-span-1 flex justify-center" data-id="element-4342">
                  {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4343">
                      <TrashIcon size={16} data-id="element-4344" />
                    </button>}
                </div>
              </div>)}
          </div>
          <div className="p-4 border-t border-blue-800/30" data-id="element-4345">
            <button onClick={handleAddPivot} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4346">
              <PlusIcon size={18} className="mr-2" data-id="element-4347" />
              Add Another Pivot
            </button>
          </div>
        </div> :
    // Grid View
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4348">
          {pivots.map((pivot, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 relative" data-id="element-4349">
              {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4350">
                  <TrashIcon size={16} data-id="element-4351" />
                </button>}
              <h3 className="text-white font-medium mb-4" data-id="element-4352">Pivot {index + 1}</h3>
              <div className="grid grid-cols-1 gap-4 mb-4" data-id="element-4353">
                <div data-id="element-4354">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4355">
                    Pivot Name
                  </label>
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter pivot name" data-id="element-4356" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-4357">
                <div data-id="element-4358">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4359">
                    Tradername
                  </label>
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4360">
                    <option value="Western" data-id="element-4361">Western</option>
                    <option value="Pierce" data-id="element-4362">Pierce</option>
                  </select>
                </div>
                <div data-id="element-4363">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4364">
                    Model
                  </label>
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4365">
                    <option value="CP600" data-id="element-4366">CP600</option>
                    <option value="8120" data-id="element-4367">8120</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-4368">
                <div data-id="element-4369">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4370">
                    Length (m)
                  </label>
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="100" max="1000" step="1" data-id="element-4371" />
                </div>
                <div data-id="element-4372">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4373">
                    Area (ha)
                  </label>
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-800/70" min="1" readOnly data-id="element-4374" />
                  <div className="text-xs text-blue-400 mt-1" data-id="element-4375">
                    Auto-calculated
                  </div>
                </div>
                <div data-id="element-4376">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4377">
                    Degrees
                  </label>
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="1" max="360" step="1" data-id="element-4378" />
                </div>
              </div>
              <div data-id="element-4379">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4380">
                  Price
                </label>
                <div className="relative" data-id="element-4381">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-4382">
                    $
                  </span>
                  <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4383" />
                </div>
              </div>
            </div>)}
          <button onClick={handleAddPivot} className="h-full min-h-[200px] rounded-xl border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex flex-col items-center justify-center" data-id="element-4384">
            <PlusIcon size={24} className="mb-2" data-id="element-4385" />
            <span data-id="element-4386">Add Another Pivot</span>
          </button>
        </div>}

      {/* Total section */}
      <div className="flex justify-end" data-id="element-4387">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4388">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4389">
            <span data-id="element-4390">Subtotal:</span>
            <span className="text-white" data-id="element-4391">
              $
              {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
            </span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4392">
            <div className="flex justify-between items-center" data-id="element-4393">
              <span className="font-medium text-white" data-id="element-4394">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4395">
                $
                {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}